import { ElementRef, InjectionToken } from '@angular/core';

export const EQA_SCROLL_REF = new InjectionToken<ElementRef<HTMLElement>>('Scrollable container');
